import general from './general';
import hubs from './hubs';
import mediaGallery from './mediaGallery';
import settings from './settings';
import generalSettings from './generalSettings';
import validation from './validation';
import chat from './chat';
import stub from './stub';
import network from './network';
import garage from './garage';
import error from './errorPage';
import wallet from './wallet';
import feedback from './feedback';
import event from './event';
import plans from './plans';
import roadmap from './roadmap';
import terms from './terms';
import policy from './policy';
import auth from './auth';
import organizers from './organizers';
import onboarding from './onboarding';
import todo from './todo';

const translationEn = {
  ...general,
  ...settings,
  ...network,
  ...hubs,
  ...generalSettings,
  ...mediaGallery,
  ...validation,
  ...todo,
  ...chat,
  ...stub,
  ...network,
  ...garage,
  ...error,
  ...wallet,
  ...feedback,
  ...event,
  ...plans,
  ...roadmap,
  ...terms,
  ...policy,
  ...auth,
  ...organizers,
  ...onboarding,
};

export default translationEn;
